<template>
  <div class="base-content-wrapper">
    <div class="content-inner-wrapper">
      <div class="select_wrap">
        <div class="select_box left"></div>
        <div class="select_box right">
          <input
            v-model.trim="filterData.stageName"
            type="text"
            class="yioks_input"
            style="width: 160px"
            placeholder="请输入关键字"
            @keyup.enter="changeQuery(true)"
          />
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>

      <div class="list_wrap" v-if="!loading && !empty">
        <div class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq">序号</div>
              <div class="th stageName">申报评估考核阶段名称</div>
              <div class="th stageStartDate">开始日期</div>
              <div class="th stageEndDate">截至日期</div>
              <div class="th description">评估简介</div>
              <div class="th status">状态</div>
              <div class="th action">操作</div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll>
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                    class="tr"
                    v-for="(item, index) in pageList"
                    :key="index"
                  >
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td stageName">
                      <p :title="item.stageName">{{ item.stageName }}</p>
                    </div>
                    <div class="td stageStartDate">
                      <p>{{ item.stageStartDate | time }}</p>
                    </div>
                    <div class="td stageEndDate">
                      <p>{{ item.stageEndDate | time }}</p>
                    </div>
                    <div class="td description">
                      <p :title="item.description">
                        {{ item.description }}
                      </p>
                    </div>
                    <div class="td status">
                      <p>{{ item.open ? "开启" : "关闭" }}</p>
                    </div>
                    <div class="td action">
                      <p>
                        <template v-if="item.submit && item.audit">
                          <span
                            class="item active"
                            @click="handleCheckDocLibrary(item)"
                            >查看文件</span
                          >
                      <p class="item active" style=" text-align: center;margin-top: 10px; color: #4cd964" @click="viewScore(item.uuid)" v-if=" ['cd37567925234e378462eec85605c63a'].includes(item.uuid)  ">
                        查看专家评分
                      </p>
                        </template>
                        <template v-else-if="!item.submit">
                          <span
                            class="item danger"
                            @click="handleEmpty(item)"
                            >未提交评估考核</span>
                        </template>
                        <template v-else-if="!item.audit">
                          <span
                            class="item danger"
                            @click="handleUnAudit(item)"
                            >审核过程中</span>
                          <p class="item active" style=" text-align: center;margin-top: 10px;color: #4cd964" @click="viewScore(item.uuid)" v-if=" item.uuid === 'cd37567925234e378462eec85605c63a' ">
                            查看专家评分
                          </p>
                        </template>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <yioks-loading v-if="loading" />
      <yioks-empty v-if="empty" tips="暂时没有数据！"></yioks-empty>
<yioks-dialog
  :title="baseScoreInfoScore.name+'——专家评分：'+baseScoreInfo.scoreTotal + '分'"
  :show-flag="isShowDialog"
  :isShowCancel="false"
  :width="'630px'"
  :successBtn="'关闭'"
  @hideDialog="hideDialogFunction"
>
<div class="dialog-content">
  <vue-scroll :ops="ops">

    <div class="info">
      <div class="col">
        <span class="title">组织架构（{{baseScoreInfoScore['7ade76fa7f784bafb1e2b961b8e81a22Score']}}分）：</span>
        <span class="score">{{ baseScoreInfo['7ade76fa7f784bafb1e2b961b8e81a22'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">机构简介（{{baseScoreInfoScore['9e89fc02a1744b9fb4996d0b8557ff2dScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['9e89fc02a1744b9fb4996d0b8557ff2d'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">发展规划（{{baseScoreInfoScore['13f86b366b1445a683d2b0f81dafb48dScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['13f86b366b1445a683d2b0f81dafb48d'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">财务管理（{{baseScoreInfoScore['69ce614f3fd24438bc1df358a6f8d46fScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['69ce614f3fd24438bc1df358a6f8d46f'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">场地数量（{{baseScoreInfoScore['footballScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo.football || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">产权租约（{{baseScoreInfoScore['footballpropertyScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo.footballproperty || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">辅助配套设施（{{baseScoreInfoScore['facilitiesScoreScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo.facilities || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">教练规模（{{baseScoreInfoScore['coachScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['coach'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">教练等级（{{baseScoreInfoScore['coachlevelScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['coachlevel'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">青训总监（{{baseScoreInfoScore['majorScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo.major || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">复合团队（{{baseScoreInfoScore['compositeteamScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo.compositeteam || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">梯队建设（{{baseScoreInfoScore['teamScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo.team || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">注册球员（{{baseScoreInfoScore['playerScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo.player || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">训练计划（{{baseScoreInfoScore['eventScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['event'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">教案质量（{{baseScoreInfoScore['planScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo.plan || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">参赛场次（{{baseScoreInfoScore['matchScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo.match || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">科学选拔（{{baseScoreInfoScore['74139d2faac144428562193ba5aa034fScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['74139d2faac144428562193ba5aa034f'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">人才输送（{{baseScoreInfoScore['playertalentScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['playertalent'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">参赛成绩（{{baseScoreInfoScore['rankScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['rank'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">赛事组织（{{baseScoreInfoScore['ddd23b38091742d69c6e80fde1dd0682Score']}}分）：</span>
        <span class="score">{{ baseScoreInfo['ddd23b38091742d69c6e80fde1dd0682'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">普及推广（{{baseScoreInfoScore['f430a991e30042d28d6341a8dcaac77dScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['f430a991e30042d28d6341a8dcaac77d'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">教育保障（{{baseScoreInfoScore['schoolScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['school'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">普及培训（{{baseScoreInfoScore['schooltrainScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['schooltrain'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">特色事项（{{baseScoreInfoScore['9b48f03515db4f3d8b24ff17e8e0b963Score']}}分）：</span>
        <span class="score">{{ baseScoreInfo['9b48f03515db4f3d8b24ff17e8e0b963'] || '--' }} 分</span>
      </div>
      <div class="col">
        <span class="title">人才质量（{{baseScoreInfoScore['qualityoftalentsScore']}}分）：</span>
        <span class="score">{{ baseScoreInfo['qualityoftalents'] || '--' }} 分</span>
      </div>
    </div>
  </vue-scroll>
</div>
</yioks-dialog>
    </div>
    <yioks-pagination :total="total" :page.sync="page"></yioks-pagination>
  </div>
</template>

<script>

import {getLibraryStageList, deleteTargetCompletedRevocation, baseScoreInfo} from "@/api/performance";
import storage from "@/utils/storage";
import mixinAppConfig from "@/mixin/mixinAppConfig";
import { ops } from '@/utils/scrollIndialog';
export default {
  mixins: [mixinAppConfig],
  data() {
    return {
      ops,
      pageList: [],
      page: 0,
      pageSize: 20,
      total: 0,
      loading: false,
      empty: false,
      filterData: {
        stageName: "",
      },
      isShowDialog: false,
      baseScoreInfo:{

      },
      baseScoreInfoScore:{

      },

    };
  },

  watch: {
    page(val) {
      this.page = val;
      this.changeQuery();
    },
  },

  created() {
    this.setQueryData();
    this.changeQuery(true);
  },

  methods: {
    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
        },
      });
      this.loadPageList();
    },

    setQueryData() {
      const { page, stageName } = this.$route.query;
      page && (this.page = Number(page));
      stageName && this.$set(this.filterData, "stageName", stageName);
    },

    loadPageList() {
      const { page, stageName } = this.$route.query;
      const paramsData = {
        page,
        stageName,
        size: this.pageSize,
      };
      this.loading = true;
      getLibraryStageList(paramsData)
        .then(res => {
          if(res.code) {
            this.loading = false;
            this.empty = true;
            this.$message.error(res.msg)
            return
          }
          const { content, totalElements, empty } = res;
          this.empty = empty;
          this.total = totalElements;
          this.pageList = content;
        })
        .catch(err => {
          console.error('err', err)
        })
      this.loading = false;
      this.empty = true;
    },

    // 查看文件库
    handleCheckDocLibrary(row) {
      const { stageName, uuid:stageUuid, groupUuid } = row;
      this.$router.push({
        path: 'docList',
        query:　{
          stageName, stageUuid, groupUuid
        }
      })
    },

    // 空数据
    handleEmpty(row) {
      this.$message.warning('当前考核阶段信息不可查看,用户未提交。')
    },
    // 空数据
    handleUnAudit(row) {
      this.$message.warning('当前为审核阶段，资料不可下载。')
    },
    viewScore(stageUuid) {
      baseScoreInfo(stageUuid)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          this.baseScoreInfo = res.resultMap;
          this.baseScoreInfoScore = res.resultMapScore;
          this.isShowDialog= true;
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    hideDialogFunction (flag, ok) {
      if (ok) {
        this.isShowDialog = flag
      } else {
        this.isShowDialog = flag
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        // height 45px
        min-height: 45px
        height: auto
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height: 45px
        height auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height inherit
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        white-space pre-line
        padding 3px 5px
        text-align: center
        line-height: 1.4em
        color $color_white
.seq
  width 6%
.stageName
  width 24%
.stageStartDate
  width 12%
.stageEndDate
  width 12%
.description
  width 24%
.status
  width 6%
.action
  width 16%
  .item
    cursor pointer
    user-select none
    &.active
      color $green_color
    &.danger
      color $red_color
    &.normal
      color #f2f2f2
  .split
    margin 0 5px
.dialog-content
  width 100%
  height 320px
  padding 10px 0px 20px
  .info
    flex 1
    border 1px solid #4cd964
    border-bottom: none
  .col
    border-bottom 1px solid #4cd964
    // border-right 1px solid #FFF
    padding 16px 15px
    display flex
    justify-content space-around
    span
      display inline-block
      width 100%
    .title
      width 80%
    .score
      width 20%
</style>

<style lang="stylus" >
.y-input
  width 180px
  margin-right 20px
  input
    border-radius 0px !important
</style>
